export const GET_PRODUCT_REQUEST = "getProductRequest";
export const GET_PRODUCT_SUCCESS = "getProductSuccess";
export const GET_PRODUCT_FAIL = "getProductFail";

export const GET_PRODUCT_DETAILS_REQUEST = 'getProductDetailsRequest'
export const GET_PRODUCT_DETAILS_SUCCESS = 'getProductDetailSuccess'
export const GET_PRODUCT_DETAILS_FAIL = 'getProductDetailFail'
export const GET_PRODUCT_DETAILS_RESET = 'getProductDetailReset'